<template>
	<div class="content-wrapper">
		<app-breadcrumb :page-title="'Attendance'" />
		<div class="mb-primary">
			<div class="card p-primary border-0">
				<teacher-pages-attendance-form-wizard :tabs="computedTabs" />
			</div>
		</div>
	</div>
</template>

<script>
const AttendanceClass = () => import("./AttendanceClass.vue");
const AttendanceClassGroup = () => import("./AttendanceClassGroup.vue");

export default {
	name: "Attendance",
	data() {
		return {
			teacherPagesAttendanceTabs: [
				{
					icon: "",
					name: "Class",
					component: AttendanceClass,
					permission: true,
					class: ""
				},
				{
					icon: "",
					name: "Class Group",
					component: AttendanceClassGroup,
					permission: true,
					class: ""
				},
			],
		};
	},
	computed: {
		computedTabs() {
			return this.teacherPagesAttendanceTabs.map((tab) => {
				if (tab.name === "Class") {
					return {
						...tab,
					};
				}
				if (tab.name === "Class Group") {
					return {
						...tab,
					};
				}
				return tab;
			});
		},
	},
};
</script>

<style scoped>
.content-wrapper {
  margin-bottom: 200px; /* Adjust the margin value as needed */
}
.card {
	box-shadow: 0 10px 12px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
</style>
